import { config } from '@react-spring/web'

export const transitionValues = {
  config: config.molasses,
  from: { y: 800, opacity: 0 },
  enter: { y: 0, opacity: 1 },
  leave: { y: 800, opacity: 0 },
}
